import { render, staticRenderFns } from "./commonAdd.vue?vue&type=template&id=b4a70a40&scoped=true"
import script from "./commonAdd.vue?vue&type=script&lang=js"
export * from "./commonAdd.vue?vue&type=script&lang=js"
import style0 from "./commonAdd.vue?vue&type=style&index=0&id=b4a70a40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a70a40",
  null
  
)

export default component.exports